module.exports = __webpack_public_path__ + "static/14-da320add0dde05658f02ef73edb8766e.jpg";